import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private msalService: MsalService) { 
    this.initializeMsal();
  }

  private async initializeMsal() {
    await this.msalService.handleRedirectObservable();
  }

  isLogged(): boolean {
    return this.msalService.instance.getActiveAccount() != null;
  }

  isTokenExpired():boolean{
    const user = this.user();
    return user?.idTokenClaims?.exp * 1000 < Date.now();
  }

  async refreshToken(): Promise<void>{
    this.msalService.instance.acquireTokenSilent({
      scopes: ["api://1232ea29-afc9-4855-bbc8-9a44ba67efd8/Users.Read"],
    })
    .then((response) => {
      const user = this.user();
      localStorage.setItem('legalresources-access-token', response.accessToken);
      localStorage.setItem('legalresources-id-token', user.idToken);
    })
    .catch((error) => {
      this.msalService.loginRedirect();
    })
  }

  user(): AccountInfo {
    return this.msalService.instance.getActiveAccount();
  }

  login() {
    this.msalService.loginRedirect();
  }

  logout() {
    this.msalService.logout();
  }

}
